import axios from 'axios'
import SearchUrlBuilder from '@/core/utils/SearchUrlBuilder'

class OrcamentoApiClient {

    async buscarTodos(filtros, paginacao) {
        const url = SearchUrlBuilder.buildAvanced(
            '/orcamento',
            filtros,
            paginacao
        )
        return axios.get(url)
    }

    async cadastrar(dados) {
        return axios.post('/orcamento/inserir/', dados)
    }

    async editar(dados) {
        return axios.put(`/orcamento/atualizar/${dados.id}`, dados)
    }

    async excluir(id) {
        return axios.delete(`/orcamento/deletar/${id}`)
    }

    async atualizarStatus(dados) {
        return axios.put('/orcamento/atualizar-status/', dados)
    }

}

export default new OrcamentoApiClient()